import { FC, HTMLAttributes } from 'react'

export const PurpleHearthIcon: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.335938" width="40" height="40" rx="20" fill="#2F3343" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2078 19.5983C10.1348 16.2483 11.3888 12.4193 14.9058 11.2863C16.7558 10.6893 18.7978 11.0413 20.3358 12.1983C21.7908 11.0733 23.9078 10.6933 25.7558 11.2863C29.2728 12.4193 30.5348 16.2483 29.4628 19.5983C27.7928 24.9083 20.3358 28.9983 20.3358 28.9983C20.3358 28.9983 12.9338 24.9703 11.2078 19.5983Z"
      stroke="#A35CFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.3359 14.7C25.4059 15.046 26.1619 16.001 26.2529 17.122"
      stroke="#A35CFE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
